import React, { Fragment } from "react";
import Banner from "./banner";

const FibreProsSection = ({ sectionLeft, sectionRight, simplePhone }) => {
  return (
    <div className="fibre-pros-section" data-cy="fibre-pros-section">
      <div className="fibre-pros-container container">
        <Banner bannerInfo={sectionLeft} className="fibre-pro-section-left" />
        <div className="banner-gap"></div>
        <Banner bannerInfo={sectionRight} phone={simplePhone} className="fibre-pro-section-right" />
      </div>
    </div>
  );
};

export default FibreProsSection;